module.exports = __webpack_public_path__ + "img/sp-1.9195a7bd.png";